import React, { Component } from "react"
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent/DialogContent"
import Dialog from "@material-ui/core/Dialog/Dialog"
import getErrorText from "../../../../library/constants/errorTypes"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import { generatePath, withRouter } from "react-router-dom"
import { createKnowmix } from "../../../../library/store/actions/creators/knowmixCreators"
import DialogActions from "@material-ui/core/DialogActions/DialogActions"
import Button from "@material-ui/core/Button/Button"
import * as routes from "../../../../library/constants/routes"
import SchoolCalendarPicker from "../../../../components/v2/inputs/pickers/schoolCalendarPicker"
import SubjectPicker from "../../../../components/v2/inputs/pickers/subjectPicker"

class CreateKnowmix extends Component {
  state = {
    name: "",
    subject: "",
    subjectError: false,
    schedule: "",
    schedulesList: [],
    scheduleError: false,
  }

  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    })
  }

  handleChangeRequired = (name) => (event) => {
    this.setState({
      [name + "Error"]: !event.target.value,
    })
    this.handleChange(name)(event)
  }

  validateSelects = () => {
    const { subject, schedule } = this.state

    this.setState({
      subjectError: !subject,
      scheduleError: !schedule,
    })
  }

  processKnowmixCreate = async () => {
    const { name, subject, schedule, subjectError, scheduleError } = this.state

    if (subjectError || scheduleError) return

    try {
      const knowmixId = await this.props.createKnowmix({
        name,
        subject_id: subject.id,
        group_id:
          this.props.match.path === routes.GROUP_SETTINGS_KNOWMIX
            ? parseInt(this.props.match.params.groupId, 10)
            : undefined,
        schedule_id: schedule.id,
      })
      await this.props.history.push(generatePath(routes.KNOWMIX, { knowmixId }))
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  render() {
    const { name, subject, subjectError, schedule, scheduleError } = this.state

    return (
      <Dialog
        aria-labelledby="create-knowmix-dialog"
        onClose={this.props.handleClose}
        open={this.props.open}
      >
        <ValidatorForm onSubmit={this.processKnowmixCreate}>
          <DialogTitle id="alert-dialog-title" className="text-center">
            New course
          </DialogTitle>
          <DialogContent>
            <div className="form form--modal">
              <div className="form__fieldset">
                <label htmlFor="name" className="form__label">
                  Course name *
                </label>
                <div className="form__fieldbox">
                  <div className="form__input">
                    <TextValidator
                      id="name"
                      name="name"
                      value={name}
                      placeholder="Type course name"
                      className="edit-form__input"
                      margin="normal"
                      fullWidth
                      validators={[
                        "required",
                        "minStringLength:3",
                        "maxStringLength:200",
                      ]}
                      errorMessages={[
                        "Field is required",
                        "Min length is 3 characters",
                        "Max length is 200 characters",
                      ]}
                      withRequiredValidator
                      onChange={this.handleChange("name")}
                    />
                  </div>
                </div>
              </div>

              <SchoolCalendarPicker
                groupId={parseInt(this.props.match.params.groupId)}
                value={schedule}
                hasError={scheduleError}
                onChange={this.handleChangeRequired("schedule")}
              />

              <SubjectPicker
                value={subject}
                required
                hasError={subjectError}
                onChange={this.handleChangeRequired("subject")}
                calendarId={
                  schedule.has_district_calendar
                    ? schedule?.calendar_id
                    : undefined
                }
                scheduleId={
                  !schedule.has_district_calendar ? schedule?.id : undefined
                }
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              onClick={this.validateSelects}
            >
              Save
            </Button>
          </DialogActions>
        </ValidatorForm>
      </Dialog>
    )
  }
}

const mapStateToProps = ({ auth, knowmix }) => ({ auth, knowmix })
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ createKnowmix }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(withRouter(CreateKnowmix)))
